/** Etiquetas en español para mostrar en el panel. */
export const ADMIN_ROLE_LABELS = {
  tendero: 'Cajero',
  cocina: 'Cocina',
  admin: 'Administrador',
  super_admin: 'Super administrador',
};

export function userRoleLabel(role) {
  const key = String(role || '').trim();
  return ADMIN_ROLE_LABELS[key] || key || 'Usuario';
}

/** Roles que pueden usar el panel (admin operativo o super). */
export function isStaffRole(role) {
  return role === 'admin' || role === 'super_admin' || role === 'tendero' || role === 'cocina';
}

export function isSuperAdmin(role) {
  return role === 'super_admin';
}

export function isTendero(role) {
  return role === 'tendero';
}

export function isCocina(role) {
  return role === 'cocina';
}

/** Admin operativo o super: gestión blacklist WA, etc. */
export function isAdminRole(role) {
  return role === 'admin' || role === 'super_admin';
}

export function canManageWaBlacklist(role) {
  return isAdminRole(role);
}
